export const palette = {
  neutral: {
    x1: '#FFFFFF',
    x2: '#F2F2F2',
    x3: '#E0E0E0',
    x4: '#A3A3A3',
    x5: '#6E6E6E',
    x6: '#525252',
    x7: '#242424',
    x8: '#161616',
    x9: '#000000',
  },
  blue: {
    x1: '#B6E4EF',
    x2: '#81CDE5',
    x3: '#002C9E',
  },
  green: {
    x1: '#BCEFC4',
    x2: '#73BF73',
    x3: '#006716',
  },
  pink: {
    x1: '#FFCEDB',
    x2: '#F598B1',
    x3: '#BF0C2C',
  },
  yellow: {
    x1: '#F7F8A4',
    x2: '#FAE57D',
    x3: '#C93D00',
  },
  success: {
    x1: '#BCEFC4',
    x2: '#2EBF7C',
    x3: '#00704B',
  },
  caution: {
    x1: '#FFD3D1',
    x2: '#F37C69',
    x3: '#D12D04',
  },
  graph: {
    blue: '#B1E8EF',
    indigo: '#2D75E0',
    green: '#6ECC78',
    yellow: '#F9EA63',
    pink: '#FFB3C6',
    gray: '#8E8E8E',
  },
};
